import _styled from '@emotion/styled/base';
import React__default from 'react';
import { AiOutlineRadiusUpright } from '@react-icons/all-files/ai/AiOutlineRadiusUpright';
import { MdLineWeight } from '@react-icons/all-files/md/MdLineWeight';
import { NumberInputField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../../contexts/internal/StickyContext.js';
import '../../../../contexts/internal/EditorContext.js';
import '../../../../components/Canvas/Canvas.style.js';
import '../../../../components/Canvas/PreviewModeContainer.js';
import '../../../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../../../components/FieldItem.js';
import '../../../../components/FormGroup/FormGroup.js';
import '../../../../components/FormGroup/LogDataFormGroup.js';
import '../../../../components/Header/index.js';
import { ColorPickerField } from '../../../../components/Input/ColorPickerField/index.js';
import '../../../../components/Input/URLInput.js';
import '../../../../components/Inspector/Inspector.js';
import '../../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../../components/Tooltip/Tooltip.js';
import '../../../../components/Toolbar/Toolbar.style.js';
import '../../../../components/TreeList/Draggable.js';
import '../../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../../../components/FormContent.js';
import { GutterField } from './GutterField.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function BoxModelForm() {
  return jsx(React__default.Fragment, null, jsx(GutterField, {
    name: "margin",
    label: "\uB9C8\uC9C4"
  }), jsx(GutterField, {
    name: "padding",
    label: "\uD328\uB529"
  }), jsx(FormContent, {
    header: "\uD14C\uB450\uB9AC",
    direction: "VERTICAL"
  }, jsx(GapWrapper, null, jsx(ColorPickerField, {
    name: "border.color",
    width: "100%"
  }), jsx(NumberInputField, {
    name: "border.width",
    width: "100%",
    label: jsx(MdLineWeight, null),
    direction: "HORIZONTAL"
  }), jsx(NumberInputField, {
    name: "border.radius",
    width: "100%",
    label: jsx(AiOutlineRadiusUpright, null),
    direction: "HORIZONTAL"
  }))));
}
var GapWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ex18u2m0"
} : {
  target: "ex18u2m0",
  label: "GapWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "7kxp26",
  styles: "display:grid;grid-template-columns:repeat(2, 1fr);gap:8px"
} : {
  name: "7kxp26",
  styles: "display:grid;grid-template-columns:repeat(2, 1fr);gap:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJveE1vZGVsRm9ybS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUM2QiIsImZpbGUiOiJCb3hNb2RlbEZvcm0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEFpT3V0bGluZVJhZGl1c1VwcmlnaHQgfSBmcm9tICdAcmVhY3QtaWNvbnMvYWxsLWZpbGVzL2FpL0FpT3V0bGluZVJhZGl1c1VwcmlnaHQnO1xuaW1wb3J0IHsgTWRMaW5lV2VpZ2h0IH0gZnJvbSAnQHJlYWN0LWljb25zL2FsbC1maWxlcy9tZC9NZExpbmVXZWlnaHQnO1xuaW1wb3J0IHsgTnVtYmVySW5wdXRGaWVsZCB9IGZyb20gJ0BidWNrZXRwbGFjZS9jb21tZXJjZS1hZG1pbi11aSc7XG5cbmltcG9ydCB7IENvbG9yUGlja2VyRmllbGQsIEZvcm1Db250ZW50IH0gZnJvbSAnQC9jb21wb25lbnRzJztcblxuaW1wb3J0IHsgR3V0dGVyRmllbGQgfSBmcm9tICcuL0d1dHRlckZpZWxkJztcblxuZXhwb3J0IGZ1bmN0aW9uIEJveE1vZGVsRm9ybSgpIHtcbiAgcmV0dXJuIChcbiAgICA8PlxuICAgICAgPEd1dHRlckZpZWxkIG5hbWU9XCJtYXJnaW5cIiBsYWJlbD1cIuuniOynhFwiIC8+XG4gICAgICA8R3V0dGVyRmllbGQgbmFtZT1cInBhZGRpbmdcIiBsYWJlbD1cIu2MqOuUqVwiIC8+XG4gICAgICA8Rm9ybUNvbnRlbnQgaGVhZGVyPVwi7YWM65GQ66asXCIgZGlyZWN0aW9uPVwiVkVSVElDQUxcIj5cbiAgICAgICAgPEdhcFdyYXBwZXI+XG4gICAgICAgICAgPENvbG9yUGlja2VyRmllbGRcbiAgICAgICAgICAgIG5hbWU9XCJib3JkZXIuY29sb3JcIlxuICAgICAgICAgICAgd2lkdGg9XCIxMDAlXCJcbiAgICAgICAgICAvPlxuICAgICAgICAgIDxOdW1iZXJJbnB1dEZpZWxkXG4gICAgICAgICAgICBuYW1lPVwiYm9yZGVyLndpZHRoXCJcbiAgICAgICAgICAgIHdpZHRoPVwiMTAwJVwiXG4gICAgICAgICAgICBsYWJlbD17PE1kTGluZVdlaWdodCAvPn1cbiAgICAgICAgICAgIGRpcmVjdGlvbj1cIkhPUklaT05UQUxcIlxuICAgICAgICAgIC8+XG4gICAgICAgICAgPE51bWJlcklucHV0RmllbGRcbiAgICAgICAgICAgIG5hbWU9XCJib3JkZXIucmFkaXVzXCJcbiAgICAgICAgICAgIHdpZHRoPVwiMTAwJVwiXG4gICAgICAgICAgICBsYWJlbD17PEFpT3V0bGluZVJhZGl1c1VwcmlnaHQgLz59XG4gICAgICAgICAgICBkaXJlY3Rpb249XCJIT1JJWk9OVEFMXCJcbiAgICAgICAgICAvPlxuICAgICAgICA8L0dhcFdyYXBwZXI+XG4gICAgICA8L0Zvcm1Db250ZW50PlxuICAgIDwvPlxuICApO1xufVxuXG5jb25zdCBHYXBXcmFwcGVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoMiwgMWZyKTtcbiAgZ2FwOiA4cHg7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { BoxModelForm };
//# sourceMappingURL=BoxModelForm.js.map
